// Centralised role-permission helpers.
// Roles: admin, qa_manager, site_engineer, client, subcontractor

const SITE_LIKE = new Set(["admin", "site_engineer"]);
const FIELD_TEAM = new Set(["admin", "site_engineer", "qa_manager", "subcontractor"]);
const QA_LIKE = new Set(["admin", "qa_manager"]);
const NCR_WRITERS = new Set(["admin", "site_engineer", "qa_manager"]);
const LOT_CREATORS = new Set(["admin", "site_engineer", "qa_manager"]);
const PLAN_EDITORS = new Set(["admin", "site_engineer", "qa_manager"]);

export const can = {
  requestHoldPointRelease: (role) => SITE_LIKE.has(role),
  submitLotForReview: (role) => SITE_LIKE.has(role),
  closeLot: (role) => QA_LIKE.has(role),
  uploadEvidence: (role) => FIELD_TEAM.has(role),
  updateChecklist: (role) => FIELD_TEAM.has(role),
  raiseNCR: (role) => NCR_WRITERS.has(role),
  createLot: (role) => LOT_CREATORS.has(role),
  createProject: (role) => role === "admin",
  approveITP: (role) => role === "admin",
  uploadPlan: (role) => PLAN_EDITORS.has(role),
  editMarkup: (role) => PLAN_EDITORS.has(role),
  comment: () => true, // everyone can comment
  createITP: (role) => role === "admin" || role === "qa_manager",
  approveITP: (role) => role === "admin" || role === "qa_manager",
};

export const isClientRole = (role) => role === "client";
export const isReadOnlyForLot = (role) =>
  role === "client" || role === "subcontractor";
